import type { IErrorCommon } from '@/shared/common/types/commonError.type';

export const TOO_MANY_REQUESTS_MESSAGE =
  'Demasiadas solicitudes. Intenta de nuevo en unos minutos';

export const ErrorsCommon: IErrorCommon = {
  NOT_FOUND: 'No se encontró el recurso',
  UNAUTHORIZED: 'Tu sesión ha caducado. Por favor, inicia sesión nuevamente.',
  FORBIDDEN: 'No tienes permisos para acceder a este recurso',
  INTERNAL_SERVER_ERROR: 'Error interno. Intenta más tarde.',
  BAD_REQUEST: 'Faltó información para ejecutar la acción.',
  TMRM: TOO_MANY_REQUESTS_MESSAGE, // Too Many Requests
  TOO_MANY_REQUESTS: TOO_MANY_REQUESTS_MESSAGE,
  THROTTLED: TOO_MANY_REQUESTS_MESSAGE,
} as const;
